var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vms__ui-link",class:{ 'vms__ui-link--disabled': _vm.disabled },attrs:{"title":_vm.disabled ? null : _vm.link,"data-link":_vm.link || null},on:{"click":_vm.goTo}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }